// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"c57dccb6","357":"175f0872","453":"27b50484","520":"6c9315a2","615":"395d773a","805":"cde672ec","881":"9819309a","964":"d800d734"}[chunkId] + ".chunk.js";
};